(function () {
  window.rdvdeco = window.rdvdeco || {};

  const RATING_THRESHOLD = 3.5;
  const HIDDEN_CLASS = 'rdvdeco-rating-hidden';

  function readStarsAverage(root) {
    const text = root.textContent || '';
    const match = text.match(/(\d+(?:[.,]\d+)?)\s*\/\s*5\b/);
    if (!match) return null;
    return parseFloat(match[1].replace(',', '.'));
  }

  function apply() {
    const lowRatedSkus = new Set();

    document.querySelectorAll('.skeepers_product__stars[data-product-id]').forEach((widget) => {
      const average = readStarsAverage(widget);
      if (average === null) return;

      const hide = average <= RATING_THRESHOLD;
      const wrapper = widget.closest('.skeepers_container') || widget;
      wrapper.classList.toggle(HIDDEN_CLASS, hide);

      if (hide) {
        const sku = widget.getAttribute('data-product-id');
        if (sku) lowRatedSkus.add(sku);
      }
    });

    document.querySelectorAll('.skeepers_product__reviews[data-product-id]').forEach((widget) => {
      const sku = widget.getAttribute('data-product-id');
      const section = widget.closest('[id^="shopify-section-"]') || widget;
      section.classList.toggle(HIDDEN_CLASS, !!(sku && lowRatedSkus.has(sku)));
    });
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }

  window.rdvdeco.applyRatingFilter = apply;

  function start() {
    apply();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
